import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, breadcrumbList, faqPage } from "@/lib/schema";
import { content } from "@/lib/content";
import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { AboutContent } from "@/components/AboutContent";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/ar/about")({
  head: () => ({
    meta: [
      { title: "عن عراق سيرت — دعم شهادات الأيزو وتسجيل الموردين" },
      {
        name: "description",
        content:
          "مقرّ عراق سيرت في أربيل. ندعم الشركات في أنحاء العراق في التحضير لشهادات الأيزو وتسجيل الموردين في قطاع النفط والغاز.",
      },
      { property: "og:title", content: "عن عراق سيرت — دعم شهادات الأيزو وتسجيل الموردين" },
      {
        property: "og:description",
        content: "مقرّ عراق سيرت في أربيل. ندعم الشركات في أنحاء العراق في التحضير لشهادات الأيزو وتسجيل الموردين في قطاع النفط والغاز.",
      },
      { property: "og:url", content: absolute("/ar/about") },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "ar_IQ" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/ar/about") }, ...hreflangLinks("/about")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          graph(
            breadcrumbList([
              { name: "الرئيسية", path: "/ar" },
              { name: "عن الشركة", path: "/ar/about" },
            ]),
            faqPage(
              "/ar/about",
              content.faq.about.map((f) => ({ q: f.q.ar, a: f.a.ar })),
            ),
          ),
        ),
      },
    ],
  }),
  component: AboutPageAr,
});

function AboutPageAr() {
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <AboutContent />
      </main>
      <Footer />
    </div>
  );
}
